import { render, staticRenderFns } from "./CollectionScrollItem.vue?vue&type=template&id=3812c786&scoped=true&"
import script from "./CollectionScrollItem.vue?vue&type=script&lang=ts&"
export * from "./CollectionScrollItem.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionScrollItem.vue?vue&type=style&index=0&id=3812c786&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3812c786",
  null
  
)

export default component.exports